import React, { FC, useState } from 'react';
import { Box, Button, Dialog, DialogBody, DialogTitle, useId } from '@sendsprint/ui-react';
import { useDashboardContext } from '@src/contexts/dashboard-context';
import { identification } from './assets';
import VeriffModalItem from './components/veriffModalItem';
import { ArrowCircleRightOutline } from '@sendsprint/ui-react/dist/icons';
// import { useMixpanel } from '@src/contexts';
// import { mixpanelEvents } from '@src/types/mixpanel';

interface Props {
  handleClick: () => void;
  state: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  stateFunc?: any;
}

const VeriffModal: FC<Props> = ({ handleClick, state, stateFunc }) => {
  const titleId = useId();
  const { handleVeriffOpenTab, isBusinessVerified, isUserVerified, isIdExpired } =
    useDashboardContext();
  const [loading, setLoading] = useState(false);
  // const { mixpanelInstance } = useMixpanel();

  const handleClickVeriff = async () => {
    setLoading(true);
    // mixpanelInstance.track(mixpanelEvents.VeriffStarted, {
    //   from: 'Veriff modal'
    // });

    await handleVeriffOpenTab();
    if (stateFunc) {
      stateFunc(false);
    }
    setLoading(false);
  };

  const handleClose = () => {
    handleClick();
  };

  return (
    <>
      <Dialog isOpen={state} onDismiss={handleClose} aria-labelledby={titleId} size="large">
        <div className="ss-text-center ss-flex ss-justify-center ss-bg-primary1-500 ss-py-12">
          <img src={identification} alt="" />
        </div>

        <DialogBody>
          <div className="ss-mb-10 ss-space-y-4">
            <DialogTitle as="h3" className="ss-text-center" id={titleId}>
              Verifications
            </DialogTitle>

            <Box>
              {!isBusinessVerified && (
                <VeriffModalItem
                  number="01"
                  body="Your business documents are undergoing reviews from our compliance team"
                  header="Business verification"
                />
              )}
              {!isUserVerified && (
                <VeriffModalItem
                  number={isBusinessVerified ? '01' : '02'}
                  body="Keep your phone within reach, you would be sharing a valid ID. Be ready to take a quick selfie."
                  header="Identity verification"
                  extraDetails={
                    <Button
                      label="Verify identity"
                      showSpinner={loading}
                      iconRight={ArrowCircleRightOutline}
                      size="small"
                      disabled={loading}
                      onClick={handleClickVeriff}
                    />
                  }
                />
              )}
              {isIdExpired && (
                <VeriffModalItem
                  number={isBusinessVerified ? '01' : '02'}
                  body="Keep your phone within reach, you would be sharing a valid ID. Be ready to take a quick selfie."
                  header="ID Expired"
                  extraDetails={
                    <Button
                      label="Verify identity"
                      showSpinner={loading}
                      iconRight={ArrowCircleRightOutline}
                      size="small"
                      disabled={loading}
                      onClick={handleClickVeriff}
                    />
                  }
                />
              )}
            </Box>
          </div>
          <div className="ss-space-y-6"></div>
        </DialogBody>

        {/* <DialogFooter>
          <div className="ss-text-center ss-flex ss-max-w-2xl lg:ss-max-w-xl ss-mx-auto">
            <Button
              onClick={handleClickVeriff}
              showSpinner={loading}
              isBlock
              label="Continue"
              variant="primary"
            />
          </div>
        </DialogFooter> */}
      </Dialog>
    </>
  );
};

export default VeriffModal;
